module.exports = __webpack_public_path__ + "static/media/1.f2c67e82.jpg";